<div [formGroup]="form">
  <div class="date-range">
    <label for="cname">Select Date</label>
    <div class="select-container">
      <select class="select" name="dtrange" #Myselect (change)="selectdate(Myselect.value)">
        <option *ngFor="let r of utilityobj.dateranges" [value]="r.dateGroup">{{r.dateRange}}</option>
      </select>
    </div>
  </div>
</div>
